import gsap, { Expo, Linear, Power2, Power4 } from 'gsap';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
// import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';
import { GetBy } from '../_app/cuchillo/core/Element';
import { isTouch } from '../_app/cuchillo/core/Basics';
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import { SplitText } from 'gsap/all';
import { Functions } from '../_app/cuchillo/utils/Functions';
import { Ease } from '../_app/cuchillo/utils/Ease';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { Metrics } from '../_app/cuchillo/core/Metrics';

const INTERVAL = 4000;

class ScrollItem__Cards extends Scroll_Item {

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);
        this.delay = .5;
        this.timeline = gsap.timeline({ paused: true });
        this.cards = [...GetBy.class("__card", __link)]
        this.setupAnimation(__link);
        this.isAnimated = false;

        this.onShow = () => {
            if(!this.isAnimated) this.showCb();
            this.showCb();
            this.isAnimated = true;
        };
        this.onHide = () => { };
        this.onMove = () => { };
    }

    showCb() {
        this.timeline.restart();
    }

    setupAnimation(dom) {
        let delay = this.delay;
        this.cards.map(dom => {
            gsap.set(dom, {opacity:0, y:Metrics.CENTER_Y, scaleX:1.1, scaleY:1.1, force3D: true});

            this.timeline.to(dom, {
                opacity: 1,
                duration: .1,
                ease: Linear.easeNone
            }, delay);

            this.timeline.to(dom, {
                y: 0,
                scaleX: 1,
                scaleY: 1,
                duration: 1,
                //rotate: 10,
                force3D: true,
                ease: Power4.easeOut
            }, delay);

            delay += 0.5;
        });
    }
}

Scroll._registerClass('Cards', ScrollItem__Cards);

export default ScrollItem__Cards;
